import React, { useState } from "react";
import { Layout, Menu } from "antd";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { useParams, useLocation } from "react-router-dom";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";
import SidebarWrapper from "./index.style";
import { useSelector } from "react-redux";
const { Sider } = Layout;

const DashboardSider = ({ routeDefinitions }) => {
  let { branchId } = useParams();
  let location = useLocation();
  const currentAppLocale = useSelector((state) => state.user.currentAppLocale);
  const [collapsed, setCollapsed] = useState(false);
  const prefix = branchId ? `/branches/${branchId}` : "/admin";
  const activeKey = location.pathname.replace(prefix + "/", "").split("/")[0];
  const direction = currentAppLocale.direction;

  const toggle = () => {
    setCollapsed(!collapsed);
  };
  const renderRoute = (r) => {
    if (r.hidden === true) {
      return null;
    }
    return {
      label: r.subMenu ? (
        <FormattedMessage id={`app.sidebar.${r.resourceName || r.resource}`} />
      ) : (
        <Link
          to={{
            pathname: `${prefix}/${r.resourceName || r.resource}`,
          }}
        >
          <FormattedMessage
            id={`app.sidebar.${r.resourceName || r.resource}`}
          />
        </Link>
      ),
      key: r.resourceName || r.resource,
      icon: r.icon,
      children:
        r.childrenResources &&
        r.childrenResources.map((k) => {
          return {
            label: (
              <Link
                to={{
                  pathname: `${prefix}/${k.resource}`,
                }}
              >
                <FormattedMessage id={`app.sidebar.${k.resource}`} />
              </Link>
            ),
            key: k.resource,
            icon: k.icon,
          };
        }),
    };
  };

  return (
    <SidebarWrapper direction={direction}>
      <Sider width={200} collapsible collapsed={collapsed} trigger={null}>
        <Menu
          mode="inline"
          defaultSelectedKeys={["users"]}
          selectedKeys={activeKey}
          style={{ height: "100%", borderRight: 0 }}
          items={routeDefinitions.map((r) => renderRoute(r))}
        />
        <div className="toggle">
          {collapsed ? (
            <MenuUnfoldOutlined onClick={toggle} />
          ) : (
            <MenuFoldOutlined onClick={toggle} />
          )}
        </div>
      </Sider>
    </SidebarWrapper>
  );
};

export default DashboardSider;
